// The 7 personas under the Family Personas section. Each persona profile is
// built from a specific combination of family and household characteristics.
import AgricultureIcon from '@mui/icons-material/Agriculture';
import EngineeringIcon from '@mui/icons-material/Engineering';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import WomanIcon from '@mui/icons-material/Woman';
import PolicyIcon from '@mui/icons-material/Policy';
import ConstructionIcon from '@mui/icons-material/Construction';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';

export const familyPersonas = [
  {
    id: 'aspirational-farmer',
    title: 'Aspirational Farmer Family',
    tagline: 'Farming, irrigation, smartphone, PM-Kisan',
    icon: AgricultureIcon,
    accent: 'var(--cat-skill-livelihood)',
  },
  {
    id: 'struggling-labour',
    title: 'Struggling Labour Family',
    tagline: 'Wage labour, low income, limited assets',
    icon: EngineeringIcon,
    accent: 'var(--warning)',
  },
  {
    id: 'emerging-youth',
    title: 'Emerging Youth Family',
    tagline: 'Young adults, skills needed, internet access',
    icon: EmojiPeopleIcon,
    accent: 'var(--cat-gender)',
  },
  {
    id: 'womens-empowerment',
    title: "Women's Empowerment Family",
    tagline: 'SHG members, eligible women',
    icon: WomanIcon,
    accent: 'var(--cat-women-child)',
  },
  {
    id: 'welfare-excluded',
    title: 'Welfare Excluded Family',
    tagline: 'Eligible but missing benefits',
    icon: PolicyIcon,
    accent: 'var(--danger)',
  },
  {
    id: 'infrastructure-deficit',
    title: 'Infrastructure Deficit Family',
    tagline: 'Poor housing, water, sanitation',
    icon: ConstructionIcon,
    accent: 'var(--cat-housing)',
  },
  {
    id: 'healthy-progressive',
    title: 'Healthy & Progressive Family',
    tagline: 'Good infrastructure, digital access, multiple schemes',
    icon: HealthAndSafetyIcon,
    accent: 'var(--success)',
  },
];

export const getFamilyPersonaById = (id) => familyPersonas.find((p) => p.id === id) || null;

export default familyPersonas;
